import type Validate from './Validate'

const email: Validate<string> = value => {
  if (!/\S+@\S+\.\S+/.test(value)) {
    return 'Email address is invalid'
  }

  return true
}

export default email
